import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { StudentService } from '../../../shared-components/student/student.service';
import { System } from '../../../shared-components/System';
import { AssessmentsReport, CaseManagementHistory, CaseManager, ImportedDocuments, SpecialServicesSummary, SpedCollectionStudentToTeamMember, SpEdSite, SpedStudentCollectionCard, SpEdSummaryCodes } from './sped-student-document-cards.model';

@Injectable({
  providedIn: 'root'
})
export class SpedStudentDocumentCardsService {
  // caseManagerDataLength = 0;

  private _caseManagerDataLength: number;
  public get caseManagerDataLength(): number {
    return this._caseManagerDataLength;
  }

  public set caseManagerDataLength(value: number) {
    this._caseManagerDataLength = value;
    this.observableCaseManagerDataLength.next(value);
  }

  public observableCaseManagerDataLength = new Subject<number>();
  observableCaseManagerDataLengthStream$ = this.observableCaseManagerDataLength.asObservable();

  private _evaluationCollectionDataLength: number;
  public get evaluationCollectionDataLength(): number {
    return this._evaluationCollectionDataLength;
  }

  public set evaluationCollectionDataLength(value: number) {
    this._evaluationCollectionDataLength = value;
    this.observableEvaluationCollectionDataLength.next(value);
  }

  public observableEvaluationCollectionDataLength = new Subject<number>();
  observableEvaluationCollectionDataLengthStream$ = this.observableEvaluationCollectionDataLength.asObservable();

  private _dataUpdated: boolean;
  public get dataUpdated(): boolean {
    return this._dataUpdated;
  }

  public set dataUpdated(value: boolean) {
    this._dataUpdated = value;
    this.observableDataUpdated.next(value);
  }

  public observableDataUpdated = new Subject<boolean>();
  observableDataUpdatedStream$ = this.observableDataUpdated.asObservable();

  constructor(private http: HttpClient,
    private studentService: StudentService) { }

  getStudentAssignedCollectionRead(studentId: number): Observable<SpedStudentCollectionCard[]> {
    const queryString = '?studentId=' + studentId;
    return this.http.get<SpedStudentCollectionCard[]>(System.apiURL.SpecialEd + 'StudentAssignedCollectionRead' + queryString);
  }

  getSpedStudentCollectionStatus(collectionId: number, showForTeamMemberOnly: boolean, stateCode: string): Observable<string> {
    const studentId = this.studentService.selectedStudent.Id;
    const queryString = '?studentId=' + studentId + '&collectionId=' + collectionId + '&showForTeamMemberOnly=' + showForTeamMemberOnly + '&stateCode=' + stateCode;
    return this.http.get<string>(System.apiURL.SpecialEd + 'GetSpedStudentCollectionStatus' + queryString);
  }

  assignCollectionToStudent(collectionId: number, addNewInstance: boolean, stateCode: string): Observable<void> {
    const studentId = this.studentService.selectedStudent.Id;
    const queryString = '?studentId=' + studentId + '&collectionId=' + collectionId + '&addNewInstance=' + addNewInstance + '&stateCode=' + stateCode;
    return this.http.post<void>(System.apiURL.SpecialEd + 'AssignCollectionToStudent' + queryString, null);
  }

  deleteAssignedCollection(spedcollectiontoStudentId: number, deleteReason: string): Observable<void> {
    const queryString = '?spedcollectiontoStudentId=' + spedcollectiontoStudentId + '&deleteReason=' + deleteReason;
    return this.http.post<void>(System.apiURL.SpecialEd + 'DeleteAssignedCollection' + queryString, null);
  }
  caseManagerTeamReadByStudent(StudentId: number): Observable<CaseManagementHistory[]> {
    const queryString = '?StudentId=' + StudentId;
    return this.http.get<CaseManagementHistory[]>(System.apiURL.SpecialEd + 'CaseManagerTeamReadByStudent' + queryString);
  }

  caseManagerTeamUpdate(data: CaseManagementHistory): Observable<CaseManagementHistory[]> {
    return this.http.post<CaseManagementHistory[]>(System.apiURL.SpecialEd + 'CaseManagerTeamUpdate', data);
  }
  siteReadByUserId(yearId: number): Observable<SpEdSite[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.get<SpEdSite[]>(System.apiURL.SpecialEd + 'SiteReadByUserId' + queryString);
  }
  caseManagerReadBySiteId(siteId: number, yearId: number): Observable<CaseManager[]> {
    const queryString = '?siteId=' + siteId + '&yearId=' + yearId;
    return this.http.get<CaseManager[]>(System.apiURL.SpecialEd + 'CaseManagerReadBySiteId' + queryString);
  }
  caseManagerTeamDelete(id: number, reasonForDelete: string): Observable<CaseManagementHistory[]> {
    const queryString = '?id=' + id + '&reasonForDelete=' + reasonForDelete;
    return this.http.post<CaseManagementHistory[]>(System.apiURL.SpecialEd + 'CaseManagerTeamDelete' + queryString, null);
  }
  spedStudentDocumentRead(studentId: number, spedCollectionToStudentId: number, callFromAssessmentReport: boolean = false): Observable<ImportedDocuments[]> {
    const queryString = '?studentId=' + studentId + '&spedCollectionToStudentId=' + spedCollectionToStudentId + '&callFromAssessmentReport=' + callFromAssessmentReport;
    return this.http.get<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentRead' + queryString);
  }

  spedStudentDocumentDelete(SpedDocumentId: number): Observable<ImportedDocuments[]> {
    const queryString = '?SpedDocumentId=' + SpedDocumentId;
    return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentDelete' + queryString, null);
  }
  spedStudentDocumentCreate(attachment: ImportedDocuments, attachmentType: string, callFromAssessmentReport: boolean = false): Observable<ImportedDocuments[]> {
    // return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentCreate?attachmentType=${attachmentType}' , attachment);
    return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + `SpedStudentDocumentCreate?attachmentType=${attachmentType}&callFromAssessmentReport=${callFromAssessmentReport}`, attachment);
  }

  saveSpedCopyCollectionWithStudentData(studentId: number, spedCollectionId: number, spedCollectionToStudentId: number, collectionToStudentTemplatesIds: string, stateCode: string, templateVersionIds: string, amendmentAnnualValue: string, teacherUserIds: string): Observable<void> {
    const queryString = '?studentId=' + studentId +
      '&spedCollectionId=' + spedCollectionId +
      '&spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&collectionToStudentTemplatesIds=' + collectionToStudentTemplatesIds +
      '&stateCode=' + stateCode + '&templateVersionIds=' + templateVersionIds + '&amendmentAnnualValue=' + amendmentAnnualValue +
      '&teacherUserIds=' + teacherUserIds;
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedCopyCollectionWithStudentData' + queryString, null);
  }

  spedCollectionStudentToTeamMember(spEdCollectionToStudentId: number, copyTeamMember: boolean): Observable<SpedCollectionStudentToTeamMember[]> {
    const queryString = '?spEdCollectionToStudentId=' + spEdCollectionToStudentId + '&copyTeamMember=' + copyTeamMember;
    return this.http.get<SpedCollectionStudentToTeamMember[]>(System.apiURL.SpecialEd + 'SpEdCollectionStudentToTeamMembersRead' + queryString);
  }

  viewBlankDocument(spedCollectionId: number): Observable<string> {
    let queryString = '';
    queryString += '?spedCollectionId=' + spedCollectionId;
    return this.http.get<string>(System.apiURL.SpecialEd + 'PrintBlankCollection' + queryString);
  }

  spedStudentCollectionStatusToCompleted(spedCollectionToStudentId: number, completedByCaseManager: boolean, workingDraft: boolean): Observable<string> {
    const queryString = '?spedCollectionToStudentId=' + spedCollectionToStudentId + '&completedByCaseManager=' + completedByCaseManager + '&workingDraft=' + workingDraft;
    return this.http.post<string>(System.apiURL.SpecialEd + 'UpdateStudentCollectionStatusToCompleted' + queryString, null);
  }

  getStudentSpEdSummary(stateCode: string, siteYearId: number): Observable<SpecialServicesSummary> {
    const queryString = '?studentId=' + this.studentService.selectedStudent.Id + '&stateCode=' + stateCode + '&siteYearId=' + siteYearId;
    return this.http.get<SpecialServicesSummary>(System.apiURL.SpecialEd + 'GetStudentSpEdSummary' + queryString);
  }

  getSpEdSummaryLegendCodes(stateCode: string): Observable<SpEdSummaryCodes[]> {
    const queryString = '?studentId=' + this.studentService.selectedStudent.Id + '&stateCode=' + stateCode;
    return this.http.get<SpEdSummaryCodes[]>(System.apiURL.SpecialEd + 'GetSpEdSummaryCodes' + queryString);
  }

  getSpedAssessmentsReports() {
    const queryString = '?studentId=' + this.studentService.selectedStudent.Id;
    return this.http.get<AssessmentsReport[]>(System.apiURL.SpecialEd + 'GetSpedAssessmentsReports' + queryString);
  }

  deleteAssessmentReport(reportId: number): Observable<boolean> {
    const queryString = '?reportId=' + reportId;
    return this.http.get<boolean>(System.apiURL.SpecialEd + 'DeleteAssessmentReport' + queryString);
  }

  updateAssessmentReportStatus(reportId: number, spedLookUpDataId: number): Observable<boolean> {
    const queryString = '?reportId=' + reportId + '&spedLookUpDataId=' + spedLookUpDataId;
    return this.http.get<boolean>(System.apiURL.SpecialEd + 'UpdateAssessmentReportStatus' + queryString);
  }

  saveReport(data: AssessmentsReport) {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SaveReport', data);
  }

}